module.exports = __webpack_public_path__ + "img/pen-nib.80c5b019.svg";